import axios from "axios";
import { API_ROUTE, headersRequest } from "../../helpers";

export const DeliveryDashboardServices = {
  getOcupationByCluster: async (data) => {
    try {
      const result = await axios.get(
        `${API_ROUTE}delivery-ocupation-cluster?StartDate=${data.start_date}&EndDate=${data.end_date}`,
        headersRequest()
      );
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },

  getformaDate: (date) => {
    if (date) {
      const dat = date.split("T")[0].split("-");
      return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }
  },
  formatCurrency: (amount) => {
    return new Intl.NumberFormat("es-ES", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  },
  getProjects: async () => {
    try {
      const result = await axios.get(`${API_ROUTE}projects`, headersRequest());
      if (result.status === 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
};
